<template>
  <div class="wrapper" v-if="showImageContainer" @mouseover="showClose = true" @mouseleave="showClose = false">
    <div class="image-container">
      <img
        @load="onImageLoad"
        @error="onImageError"
        :src="imgBase64"
        alt="image"
        class="image"
        :style="{ maxWidth: imgWidth, height: 'auto' }"
      />
    </div>
    <button v-if="showCloseButton && showClose" class="close-btn" @click.prevent="closeImage">
      <img src="@/assets/images/icons/close-img.svg"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "ImageRender",
  props: {
    imgBase64: {
      type: String,
      required: true
    },
    imgWidth: {
      type: [Number,String],
      default: "208px" // Default width
    },
    imgHeight: {
      type:[Number,String],
      default: "auto" // Default height
    },
    width: {
      type: [Number,String],
      default: 0 // Default width
    },
    height: {
      type: [Number,String],
      default: 0 // Default height
    },
    showCloseButton: {
      type: Boolean,
      default: true // Default value
    },
    imageKey: {
      type: [Number,String],
      default: 0 // imageKey
    },
    showImageContainer: {
      type: Boolean,
      default: false // Default value
    }
  },
  data() {
    return {
      imageRenders: false,
      showClose: false
    };
  },
  methods: {
    closeImage() {
      this.$emit("close");
    },
    onImageLoad() {
      this.imageRenders = true;
    },
    onImageError() {
      this.imageRenders = false;
    }
  }
};
</script>

<style scoped>
/* Wrapper to position button outside */
.wrapper {
  position: relative;
  display: inline-block;
}

/* Image container */
.image-container {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
  position:relative;
}

/* Image */
.image {
  display: block;
  border-radius: 5px;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
}

/* Close button */
.close-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  background-color: #dee0df;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  aspect-ratio: 1 / 1;
  min-width: 15px;
  min-height: 15px;
  font-size: 11px;
  font-family: "Gothic A1", sans-serif;
  font-weight: bold;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Button hover effect */
.close-btn:hover {
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}
</style>
